/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import Button from 'flarum/common/components/Button';
import type Mithril from 'mithril';
import isOwnBookshelf from '../helpers/isOwnBookshelf';
import type Bookshelf from '../../common/models/Bookshelf';

export interface BookshelfPrivacyDropdownAttrs extends ComponentAttrs {
	bookshelf: Bookshelf | null;
}

export default class BookshelfPrivacyDropdown<
	CustomAttrs extends BookshelfPrivacyDropdownAttrs = BookshelfPrivacyDropdownAttrs,
> extends Component<CustomAttrs> {
	view(): Mithril.Children {
		const { bookshelf } = this.attrs;

		if (bookshelf && isOwnBookshelf(bookshelf)) {
			return (
				<SelectDropdown buttonClassName={`BookshelfPrivacyDropdown ${bookshelf.isPrivate() ? 'private' : 'public'}`} caretIcon="far fa-chevron-down">
					<Button active={bookshelf.isPrivate()} icon={bookshelf.isPrivate() ? 'fas fa-check' : true} onclick={() => this.savePrivacy(true)}>
						{app.translator.trans('glowingblue-orell-bookshelf.forum.bookshelves.status_private')}
					</Button>
					<Button active={!bookshelf.isPrivate()} icon={!bookshelf.isPrivate() ? 'fas fa-check' : true} onclick={() => this.savePrivacy(false)}>
						{app.translator.trans('glowingblue-orell-bookshelf.forum.bookshelves.status_public')}
					</Button>
				</SelectDropdown>
			);
		} else {
			return <span></span>;
		}
	}

	savePrivacy(isPrivate: boolean): void {
		const { bookshelf } = this.attrs;

		bookshelf?.save({ isPrivate }).then(m.redraw);
	}
}
